<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="col-12 md:col-4 lg:col-4 nopad">
        <p-fieldset class="p-field nopad" legend="{{'Cf_Infos' | translate}}">
          <span class="p-float-label size_cent">
            <input formControlName="name" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cfb_Name' | translate}} *</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <input formControlName="label" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cfb_Label' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <div>{{'Cfb_Desc' | translate}}</div>
            <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
          </span>
        </p-fieldset>
      </div>
      <p-fieldset class="p-field col-12 md:col-4 lg:col-4 nopad" legend="{{'Users' | translate}}">
        <p-listbox
          formControlName="userListUsed"
          [options]="userList"
          multiple="multiple"
          checkbox="checkbox"
          scrollHeight="51vh"
          >
        </p-listbox>
      </p-fieldset>
      <p-fieldset class="p-field col-12 md:col-4 lg:col-4 nopad" legend="{{'Cf_Groups' | translate}}">
        <p-listbox
          formControlName="groupListUsed"
          [options]="groupList"
          multiple="multiple"
          checkbox="checkbox"
          scrollHeight="51vh"
          >
        </p-listbox>
      </p-fieldset>
    </div>
  </form>
</div>

<div class="col-12 lg:col-12 md:col-12 align-right">
  <!-- @if (dataItem) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  } -->
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
